module.exports = __webpack_public_path__ + "static/turtle-644af127d33a58db5f72f531d02f198b.svg";